import globalStore from "store2";

export const store: globalStore.StoredData = globalStore.namespace("togglhire");
